import { useRef } from 'react';

const FileUploader = ({ 
    onFilesSelected, 
    accept = '.dcm,application/dicom,image/*',
    multiple = true,
    label = 'Choose files',
    style = {}
}) => {
    const inputRef = useRef(null);

    return (
        <div>
            <input
                ref={inputRef}
                type="file"
                className="file-input"
                multiple={multiple}
                onChange={onFilesSelected}
                accept={accept}
                style={{ display: 'none' }}
            />
            <button
                type="button"
                className="btn-primary"
                onClick={() => inputRef.current && inputRef.current.click()}
                style={style}
            >
                {label}
            </button>
        </div>
    );
};

export default FileUploader;
